import { render, staticRenderFns } from "./RegisterRules.vue?vue&type=template&id=1f6b8376&scoped=true&"
import script from "./RegisterRules.vue?vue&type=script&lang=js&"
export * from "./RegisterRules.vue?vue&type=script&lang=js&"
import style0 from "./RegisterRules.vue?vue&type=style&index=0&id=1f6b8376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6b8376",
  null
  
)

export default component.exports